import {
  PanelContainer,
  PanelSeparator,
  openURL,
  useIsDesktop,
  useIsLargeDesktop,
  useIsSM,
  useIsXS,
} from '@eCommerce/frontend-legacy-shared-library-native';
import ConnectedOfferCard from 'containers/OfferCard';
import {Offer} from 'models/Offer';
import {Box, ScrollView, Text, View} from 'native-base';
import {useTheme} from 'styled-components/native';
import {AdobeEvent, useTrackEvent} from 'hooks/useTrackEvent';
import React from 'react';

export interface FeaturedOffersModuleProps {
  featuredOffers: Offer[];
}

const FeaturedOffersModule: React.FC<FeaturedOffersModuleProps> = ({
  featuredOffers,
}) => {
  const theme = useTheme();
  const {tuna} = theme.colors as any;
  const isXS = useIsXS();
  const isSM = useIsSM();
  const isDesktop = useIsDesktop();
  const isLargeDesktop = useIsLargeDesktop();
  const {trackAdobeEvent} = useTrackEvent();

  const renderOffers = () => {
    return (
      <ScrollView
        horizontal={isSM ? true : false}
        showsVerticalScrollIndicator={false}
        pt="25px"
        pl={isSM ? '25px' : undefined}
        px={isSM ? undefined : '16px'}
        pb={
          isLargeDesktop ? '32px' : isDesktop ? '24px' : isSM ? '20px' : '16px'
        }
        zIndex={9999}>
        {featuredOffers.slice(0, 3).map((offer: Offer) => {
          return (
            <Box
              mr={isXS ? '15px' : undefined}
              mb={isSM ? '15px' : '25px'}
              key={offer.id + offer.title}
              zIndex={9999}
              /**
               * TODO: Work with Design/Product to determine how Offers should be presented on the Home screen
               *
               * Determine how Offers on the Home page should look, or adapt current Offers presentation for this screen? Use the ListView option on smaller breakpoints, or keep things consistent?
               *
               */
            >
              <ConnectedOfferCard
                cardIndex={1}
                offer={offer}
                setSelectedGrouping={() => {}}
              />
            </Box>
          );
        })}
      </ScrollView>
    );
  };

  return featuredOffers.length > 0 ? (
    <PanelContainer
      panelTitle="Your Offers"
      icon="tag"
      primaryCTA={{
        label: 'See all offers',
        onPress: () => {
          trackAdobeEvent({
            event: AdobeEvent.click,
            click: {
              name: 'my rewards home see all offers',
            },
          });
          openURL('/rewards/offers');
        },
      }}
      contentMaxWidth="100%">
      <Text
        fontFamily="body"
        fontSize="16px"
        lineHeight="25px"
        color={tuna}
        maxWidth="678px">
        Explore these Caesars Rewards offers and treat yourself to an adventure.
      </Text>
      {renderOffers()}
    </PanelContainer>
  ) : null;
};

export default FeaturedOffersModule;
